<ng-content select="[tiimeContainerHeader]"></ng-content>
<div class="tiime-container-content-container" [class.tiime-container-has-footer]="containerHasFooter">
  <div class="tiime-container-content-container__main-content">
    @if (containerState === ContainerState.contentPlaceholder) {
      <ng-content select="[tiimeContainerContentPlaceholder]"></ng-content>
    }
    @if (containerState === ContainerState.noResult) {
      <ng-content select="[tiimeContainerNoResult]"></ng-content>
    }
    <ng-content select="[tiimeContainerContent]"></ng-content>
  </div>
  <ng-content select="[tiimeContainerSideContent]"></ng-content>
</div>
<ng-content select="[tiimeContainerFooter]"></ng-content>
@if (containerState === ContainerState.onboard) {
  <ng-content select="[tiimeContainerOnboard]"></ng-content>
}
